export default "__VITE_ASSET__BaUeSN_U__"